import { graphql } from '@/gql'

export const CreateMilestonesMutation = graphql(/* GraphQL */ `
  mutation CreateMilestonesMutation($input: CreateMilestonesInput!) {
    createMilestones(input: $input) {
      ...MilestoneType
    }
  }
`)

export const UpdateMilestonesMutation = graphql(/* GraphQl */ `
  mutation UpdateMilestonesMutation($input: UpdateMilestonesInput!) {
    updateMilestones(input: $input) {
      ...MilestoneType
    }
  }
`)

export const DeleteMilestonesMutation = graphql(/* GraphQl */ `
  mutation DeleteMilestonesMutation($input: DeleteMilestonesInput!) {
    deleteMilestones(input: $input) {
      id
    }
  }
`)
